<div *ngIf="withOverlay" class="base-modal-overlay" [class.hidden]="!isOpen" (click)="close.emit()"></div>

<div class="paper base-modal" [class.hidden]="!isOpen">
  <div *ngIf="withHeader" class="paper base-modal-header">
    <ng-content select="[header]"></ng-content>

    <button class="icon-btn icon-btn_md" (click)="close.emit()">
      <img src="assets/img/icons/times.svg" alt="Close modal" />
    </button>
  </div>

  <ng-content></ng-content>
</div>
